/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router";
import { App } from "./App.tsx";
import "./i18n.ts";

function start() {
  // Do not hydrate the React SPA if we are on a static SSR page (Knowledge Base).
  // This preserves the pre-rendered HTML while still allowing Bun to inject Tailwind CSS,
  // and efficiently preloads the SPA bundle in the background for when the user clicks a link.
  if (
    window.location.pathname.startsWith("/static/artikkel/")
    || window.location.pathname.startsWith("/static/articles/")
    || window.location.pathname.startsWith("/static/statyi/")
    || window.location.pathname === "/static/artiklid"
    || window.location.pathname === "/static/articles"
    || window.location.pathname === "/static/statyi"
  ) {
    return;
  }

  const root = createRoot(document.getElementById("root")!);
  root.render(
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/chat/:sessionId" element={<App />} />
      </Routes>
    </BrowserRouter>,
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
